var render, staticRenderFns
import script from "./CollapsibleBox.vue?vue&type=script&lang=js&"
export * from "./CollapsibleBox.vue?vue&type=script&lang=js&"
import style0 from "./CollapsibleBox.vue?vue&type=style&index=0&id=7b2d9537&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2d9537",
  null
  
)

export default component.exports